import React, { useState } from 'react'
import { useApplications } from '@/hooks/useApplications'
import { Paginator } from '@/components/ui/Paginator'
import { ApplicationsList } from '@/components/app/applications/ApplicationsList'
import { Button } from '@/components/ui/button'
import { RefreshCw } from 'lucide-react'
import { useProgrammeMap } from '@/hooks/useProgrammeMap'

const primary = '#7b2a40'

const ApplicationsPage: React.FC = () => {
    const {
        applications,
        meta,
        page,
        perPage,
        isFetching,
        error,
        refetch,
        goToPage,
        changePerPage,
    } = useApplications()
    const { data: programmeNameById } = useProgrammeMap()
    const [viewMode, setViewMode] = useState<'grid' | 'table'>('grid')


    return (
        <div className="space-y-6">
            <div className="flex justify-between items-center">
                <div>
                    <h1 className="text-2xl font-bold text-gray-900">Applications</h1>
                    <p className="text-gray-600">View and manage submitted applications</p>
                </div>
                <Button onClick={() => refetch()} className="bg-primary-600 hover:bg-primary-700">
                    <RefreshCw className="h-4 w-4 mr-2" />
                    Refresh
                </Button>
            </div>

            {isFetching && (
                <div className="p-10 text-center border rounded-xl bg-white text-gray-500">
                    Loading applications...
                </div>
            )}

            {error && (
                <div className="p-4 bg-red-50 border border-red-200 text-red-700 rounded-md">
                    {error.message}
                </div>
            )}

            {!isFetching && !error && (
                <>
                    <ApplicationsList
                        items={applications}
                        viewMode={viewMode}
                        onViewModeChange={setViewMode}
                        programmeNameById={programmeNameById}
                    />
                    <Paginator
                        meta={meta}
                        page={page}
                        perPage={perPage}
                        onPageChange={goToPage}
                        onPerPageChange={changePerPage}
                    />
                </>
            )}
        </div>
    )
}

export default ApplicationsPage
